import { useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "@/i18n";

export const SECTION_IDS = {
  home: "inicio",
  why: "por-que",
  circuit: "circuito",
  transparency: "transparencia",
  imagery: "territorios",
  contact: "contacto",
};

export const stripLang = (pathname) => {
  const stripped = pathname.replace(/^\/(ar|en)(?=\/|$)/, "");
  return stripped === "" ? "/" : stripped;
};

export const useLang = () => {
  const { lang } = useParams();
  return SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
};

export const smoothScrollTo = (id) => {
  if (typeof document === "undefined") return false;
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
};

export const scrollPageTop = () => {
  if (typeof window === "undefined") return;
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};

/**
 * Navigates to an anchor on the home page from anywhere in the site,
 * always using smooth scrolling.
 */
export const useSectionNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lang = useLang();

  return useCallback(
    (sectionId) => {
      const isHome = stripLang(location.pathname) === "/";
      if (isHome) {
        const ok = smoothScrollTo(sectionId);
        if (!ok) scrollPageTop();
        if (typeof window !== "undefined" && window.history?.replaceState) {
          window.history.replaceState(null, "", `${location.pathname}#${sectionId}`);
        }
        return;
      }
      navigate(`/${lang}#${sectionId}`);
    },
    [lang, location.pathname, navigate],
  );
};
